<template>
    <v-layout wrap>
        <v-flex xs12 py-1>
            <v-text-field
                    class="search-field"
                    :readonly="loadingDNISearch"
                    :loading="loadingDNISearch"
                    ref="searchDNIInput"
                    width="200px"
                    maxlength="12"
                    color="primary"
                    hide-details
                    :value="dni | rut"
                    @input="value => dni = value ? value.replace(/\.\-/g, '') : value"
                    append-icon="search"
                    outlined
                    clearable
                    :label="label"
                    type="text"
                    :rules="rutRules"
                    @click:append="$refs.searchDNIInput.focus();$refs.searchDNIInput.blur()"
                    @click:clear="clearDNI"
                    @blur="searchDNI"
                    @keyup.enter.native="$refs.searchDNIInput.blur()"
            ></v-text-field>
        </v-flex>
        <patient-sign-up
                :internal="internal"
                :provider-id="providerId"
                :model="showPatientSignUp"
                :onCancel="onSignUpCancel"
                :dni="dni"
                :onSignUpSuccess="onSignUpSuccess"
                :requiredFields="requiredFields"
                :requestedFields="requestedFields"
                />
    </v-layout>
</template>
<script>

    import {rutValidator, rutFormat} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'
    import PatientSignUp from '../../../components/common/signup/PatientSignUp.vue'

    import {mapMutations} from 'vuex'

    export default{
        components: {PatientSignUp},
        props:{
            internal: {
                type: Boolean,
                default: false
            },
            label:{
               type: String,
               default: 'Ingresar RUT'
            },
            requiredFields:{
                type: Array
            },
            requestedFields:{
                type: Array
            },
            providerId:{
                type: Number
            }
        },
        data(){
            return {
                showPatientSignUp: false,
                loadingDNISearch: false,
                foundDNIUser: null,
                rutRules: [
                    rutValidator
                ],
                dni: '',
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearDNI(evt){
                var vm = this
                vm.dni = ''
                vm.foundDNIUser = null
            },
            async searchDNI(){
                var vm = this
                if(rutValidator(vm.dni) !== true){
                    vm.showSnackBar('El RUT ingresado es inválido')
                    return
                }

                vm.loadingDNISearch = true
                const url = vm.internal ? 'user/dni' : 'public/user/dni'
                const response = await ApiUtils.makeGet(url, {
                    dni: vm.dni
                })
                vm.loadingDNISearch = false

                if(response.ok){
                    const json = await response.json()
                    let patient = json.result.user
                    vm.foundDNIUser = patient
                    return
                }

                const json = await response.json()
                if(json.code == 404){
                    vm.showSnackBar('RUT no encontrado')
                    //todo: open patient signup dialog
                    vm.showPatientSignUp = true
                    vm.foundDNIUser = null
                    return
                }

            },
            onSignUpSuccess(user){
                var vm = this
                vm.foundDNIUser = user
                vm.showPatientSignUp = false
                vm.dni = rutFormat(user.dni)
            },
            onSignUpCancel(){
                this.showPatientSignUp = false
            },
        },
        computed:{

            client(){

                var vm = this
                if(!vm.foundDNIUser) return null

                return {
                    id: vm.foundDNIUser.id,
                    avatar: vm.foundDNIUser.avatar,
                    gender: vm.foundDNIUser.gender,
                    firstName: vm.foundDNIUser.first_name,
                    lastName: vm.foundDNIUser.last_name || '',
                    email: vm.foundDNIUser.email || '',
                    phone1: vm.foundDNIUser.phone1 || '',
                    phone2: vm.foundDNIUser.phone2 || '',
                }

            }

        },
        watch:{
            client(val){
                this.$emit('change', val)
                if(val){
                    this.dni = ''
                }
            }
        }
    }
</script>

<style scoped>
    /*
    .search-field >>>.v-text-field__slot input
    {
        margin-top: 5px !important;
        padding: 0 !important;
    }
    .search-field >>>.v-input__append-inner{
        margin-top: 10px !important;
        padding: 0 !important;
    }

    .search-field >>>.v-input__slot{
        border-radius: 50px !important;
        padding: 5px 20px !important;
        margin: 5px !important;
    }
    */
</style>
